import { UiControl } from './ui-control.model';

export class DateControl extends UiControl<Date | null> {

  constructor(id: string, label: string, value: Date | null) {
    super(id, label, value, false);
    this.className = "DateControl";
  }

}
